export default __webpack_public_path__ + "static/media/Natas.5d4d2277.jpg";